import React from 'react';
import { ContentRow } from '../ContentRow';
import { Header3, Paragraph3 } from '@cian/ui-kit';

export function BankLabelPopup() {
  return (
    <ContentRow>
      <Header3>Залоговая недвижимость</Header3>
      <Paragraph3>
        Это имущество, которое переходит в собственность банка,
        <br />
        если заемщик не исполняет обязательства по договору
        <br />
        займа перед банком
      </Paragraph3>
    </ContentRow>
  );
}
